export default __webpack_public_path__ + "static/media/vendor-spiker3.c8ae3787.jpg";